export const REGISTER_USER = '@auth/REGISTER_USER';
export const REGISTER_USER_SUCCESS = '@auth/REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILURE = '@auth/REGISTER_USER_FAILURE';


export const LOGIN_USER = '@auth/LOGIN_USER';
export const LOGIN_USER_SUCCESS = '@auth/LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = '@auth/LOGIN_USER_FAILURE';
// Password was correct but the account is due for its periodic 2FA re-verification — login
// isn't complete yet; the UI should show the code-entry step instead of navigating away.
export const LOGIN_USER_REQUIRES_2FA = '@auth/LOGIN_USER_REQUIRES_2FA';

export const VERIFY_LOGIN_2FA = '@auth/VERIFY_LOGIN_2FA';
export const VERIFY_LOGIN_2FA_SUCCESS = '@auth/VERIFY_LOGIN_2FA_SUCCESS';
export const VERIFY_LOGIN_2FA_FAILURE = '@auth/VERIFY_LOGIN_2FA_FAILURE';
// "Back" from the code-entry step to the credentials form — pure local state reset, no API call.
export const RESET_LOGIN_2FA = '@auth/RESET_LOGIN_2FA';

export const LOGOUT = '@auth/LOGOUT';

export const UPDATE_USER_PROFILE = '@auth/UPDATE_USER_PROFILE';
